<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="control is-vertical" v-show="generic && parseInt(context.$store.state.config.user.level) < 99">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Type</label>
              <select class="select is-fullwidth" v-model="occurrence.typeOccurrence" name="typeOccurrence" id="typeOccurrence" @change="clearSubject()">
                <option value="0">Internal</option>
                <option value="1">External</option>
              </select>
            </p>
          </div>
        </div>
        <div class="control is-vertical" v-show="parseInt(context.$store.state.config.user.level) < 99">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Type</label>
              <select class="select is-fullwidth" v-model="occurrence.type" name="type" id="type" @change="changeType">
                <option v-for="typeSelected in context.$store.state.config.occurrence.type" :value="typeSelected.id" :key="typeSelected.id">{{ typeSelected.name }}</option>
              </select>
            </p>
          </div>
        </div>
        <template v-if="parseInt(context.$store.state.config.user.level) < 99 && parseInt(occurrence.typeOccurrence) == 1">
          <div class="control is-vertical">
            <div class="control is-grouped">
              <p class="control is-expanded">
                <label class="label">Select Customer</label>
                <v-select
                	@search="getCustomers"
                  :options="customers"
                	placeholder="Search a customer"
                	label="name"
                  max-height="200px"
                  v-model="occurrence.customer"
                >
                </v-select>
              </p>
            </div>
          </div>
        </template>
        <div class="control is-vertical" v-if="(parseInt(occurrence.type) == 1 && users && parseInt(context.$store.state.config.user.level) < 99) || (occurrence.customer && users && parseInt(context.$store.state.config.user.level) < 99)">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">User</label>
              <select :class="{'select': true, 'is-fullwidth': true, 'is-danger': errors.has('user') }" v-model="occurrence.user" name="user" id="user" v-validate="'required'">
                <option v-for="user in users" :value="user" :key="user.id">{{ user.name }}</option>
              </select>
              <span v-show="errors.has('user')" class="help is-danger">{{ errors.first('user') }}</span>
            </p>
          </div>
        </div>
        <template>
          <div class="control is-vertical">
            <div class="control is-grouped">
              <p class="control is-expanded">
                <label class="label">Booking</label>
                <input :class="{'input': true, 'is-disabled': true }" name="booking" id="booking" type="text" placeholder="Booking" v-model="occurrence.booking">
              </p>
              <p class="control is-expanded">
                <label class="label">Service</label>
                <input :class="{'input': true, 'is-disabled': true }" name="service" id="service" type="text" placeholder="Service" v-model="occurrence.service">
              </p>
            </div>
          </div>
        </template>
        <template v-if="parseInt(context.$store.state.config.user.level) === 99">
          <div class="control is-vertical">
            <div class="control is-grouped">
              <p class="control is-expanded">
                <label class="label">Contact Name</label>
                <input :class="{'input': true}" name="contact_name" id="contact_name" type="text" v-model="occurrence.contactName">
              </p>
              <p class="control is-expanded">
                <label class="label">Contact Phone</label>
                <input :class="{'input': true}" name="contact_phone" id="contact_phone" type="text" v-model="occurrence.contactPhone">
              </p>
            </div>
          </div>
          <div class="control is-vertical">
            <div class="control is-expanded">
              <label class="label">Optional Users</label>
              <v-select
                :options="optionalCustomerUsers"
                placeholder="Choose users to also receive notifications"
                label="name"
                max-height="200px"
                v-model="occurrence.optionalCustomerUsers"
                name="optionalCustomerUsers"
                id="optionalCustomerUsers"
                multiple
              >
              </v-select>
            </div>
          </div>
        </template>
        <div class="control is-vertical">
          <div class="control is-expanded">
            <label class="label">Subject</label>
            <v-select
              :options="subjects"
              placeholder="Search a subject"
              label="subject"
              max-height="200px"
              v-model="subject"
              name="subject"
              id="subject"
              @input="setSelectedSubject"
            >
            </v-select>
            <span v-show="subjectError" class="help is-danger">Select a valid subject</span>
          </div>
        </div>
        <div class="control is-vertical" v-show="parseInt(context.$store.state.config.user.level) < 99 && parseInt(occurrence.type) === 2 && (subject && parseInt(subject.id) !== 14)">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Department</label>
              <select class="select is-fullwidth" v-model="department" name="department" id="department">
                <option v-for="departament in context.$store.state.config.departaments" v-bind:value="departament.id" v-if="parseInt(departament.id) == 1 || parseInt(departament.id) == 2">{{ departament.name }} - {{ departament.tips }}</option>
              </select>
            </p>
          </div>
        </div>
        <div class="control is-vertical">
          <div class="control">
            <label class="label">Ticket</label>
            <textarea :class="{'textarea': true, 'is-danger': errors.has('occurrence') }" name="occurrence" id="occurrence" placeholder="Explain how we can help you" v-model="occurrence.occurrence" v-validate="'required'"></textarea>
            <span v-show="errors.has('occurrence')" class="help is-danger">{{ errors.first('occurrence') }}</span>
          </div>
        </div>
        <div class="control is-vertical">
          <div class="control">
            <vue-dropzone ref="dropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-queue-complete="vdSuccess" @vdropzone-sending="vdSendingEvent"></vue-dropzone>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" :class="{'is-disabled': inProgress, 'is-loading': inProgress}" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="openOccurrence()">Open</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import _ from 'lodash'
  export default {
    props: {
      context: {
        type: Object
      },
      internal: {
        type: Boolean,
        defatult: false
      },
      generic: {
        type: Boolean,
        defatult: false
      },
      disabled: {
        type: Boolean,
        defatult: false
      },
      booking: {
      },
      service: {
        type: Number
      },
      integration: {
        type: Number
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        title: 'New Ticket',
        occurrence: {
          id: '',
          booking: '',
          service: '',
          service_id: '',
          reason: 1,
          subject: '',
          occurrence: '',
          type: 1,
          user: '',
          customer: '',
          attachments: 0,
          typeOccurrence: 0,
          contactName: '',
          contactPhone: '',
          integration: 1,
          department: '',
          optionalCustomerUsers: ''
        },
        subject: null,
        subjectError: false,
        subjects: [],
        customers: [],
        users: [],
        optionalCustomerUsers: [],
        department: 1,
        inProgress: false,
        dropzoneOptions: {
          url: this.context.$store.state.config.apiURL + '/occurrences/files',
          maxFilesize: 10,
          acceptedFiles: 'image/*,application/pdf,.doc,.docx,.csv,.xls,.xlsx,.txt,.eml,.log,.xml,.json',
          autoProcessQueue: false,
          dictDefaultMessage: 'Upload Files (max size 10MB)',
          headers: {
            'Authorization': 'Bearer ' + this.context.$store.state.config.token.access_token
          },
          addRemoveLinks: true
        },
        occurrence_id: null
      }
    },
    watch: {
      'occurrence.customer': function (val) {
        if ((val !== '') && (val !== null)) {
          this.context.$http.get(this.context.$store.state.config.apiURL + '/occurrences/users/agency/' + this.occurrence.customer.id).then((response) => {
            this.users = response.body
          }, (response) => {
          })
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.generic) {
          if (window.confirm('If you have an existing reservation, please open the ticket using the reservation you have in services.')) {
          } else {
            document.body.appendChild(this.$el)
          }
        } else {
          document.body.appendChild(this.$el)
        }
        if (this.booking !== '' && this.service !== '') {
          this.occurrence.booking = this.booking
          this.occurrence.service = this.service
        }
        this.occurrence.integration = this.integration
        if (parseInt(this.context.$store.state.config.user.level) < 99) {
          this.occurrence.type = 2
        }
        this.getSubjects()
        if (parseInt(this.context.$store.state.config.user.level) === 99) {
          this.getOptionalCustomerUsers()
        }
      })
    },
    methods: {
      getOptionalCustomerUsers () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/occurrences/users/agency/' + this.context.$store.state.config.user.agency_id).then((response) => {
          this.optionalCustomerUsers = response.body
        })
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      clearSubject () {
        this.subjectError = false
        this.subject = null
      },
      setSelectedSubject () {
        this.subjectError = false
        this.department = this.subject.department
      },
      getSubjects () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/occurrences_customer/subject/all', { params: { 'internal': this.occurrence.type } }).then(response => {
          this.subjects = response.body
        })
      },
      openOccurrence () {
        if (this.subject === null) {
          this.subjectError = true
        }
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0 && !this.subjectError) {
            this.inProgress = true
            if (this.$refs.dropzone.getQueuedFiles().length > 0) {
              this.occurrence.attachments = 1
            }
            if (parseInt(this.occurrence.type) === 2) {
              this.subject.department = this.department
            }
            this.occurrence.subject = this.subject
            this.context.$http.post(this.context.$store.state.config.apiURL + '/services/validate', this.occurrence).then((response) => {
              this.occurrence.service_id = response.body
              this.context.$http.post(this.context.$store.state.config.apiURL + '/occurrences_customer', this.occurrence).then((response) => {
                this.occurrence.id = response.body.id
                this.occurrence_id = response.body.id
                if (this.$refs.dropzone.getQueuedFiles().length > 0) {
                  this.$refs.dropzone.processQueue()
                } else {
                  window.location.reload()
                  this.close(false, {ok: true, occurrence: response.body})
                }
              }, (response) => {
                window.location.reload()
                this.close(false, {ok: false, message: response.body})
              })
            }).catch(() => {
            })
          }
        })
      },
      vdSuccess (file, xhr, formData) {
        window.location.reload()
        this.inProgress = false
        this.close(false, {ok: true, occurrence: this.occurrence})
      },
      vdSendingEvent (file, xhr, formData) {
        formData.append('occurrence_id', this.occurrence_id)
      },
      getCustomers: _.debounce(function (search, loading) {
        if (search.length) {
          loading(true)
          this.context.$http.get(this.context.$store.state.config.apiURL + '/occurrences/customers', { params: {'query': search}
          }).then(response => {
            this.customers = response.body
            loading(false)
          })
        }
      }, 500),
      changeType () {
        if (this.occurrence.type === 1) {
          this.context.$http.get(this.context.$store.state.config.apiURL + '/users/booking/' + this.occurrence.booking + '/service/' + this.occurrence.service).then((response) => {
            this.users = response.body
          }, (response) => {
          })
        }
      }
    },
    components: {
      vSelect,
      vueDropzone: vue2Dropzone
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">
  #dropzone .dz-success-mark, .dz-error-mark, .dz-remove {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// NewOccurrence.vue?5555b192